<template>
  <div>
    <img class="mx-auto h-14" :src="imagePath" alt='RMS Logo'>
  </div>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'RmsLogo',
  components: {},
  props: {
    logoColor: {
      type: String,
      required: false,
      default: 'light_sans_company',
    }
  },

  setup(props) {
    const imagePath = computed(() => {
      return `/assets/images/logos/RMS_${props.logoColor}.svg`
    })

    return {
      imagePath,
    }
  },

}
</script>
